import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { MySportProfileListItem, PublicProfileModel, UserProvider } from '../../../../providers/user/user';
import { ValueProvider } from '../../../../providers/value/value';
import { ResultProfilePage } from '../../../results/result-profile/result-profile';
import { SessionProvider } from '../../../../providers/session/session';


/**
 * Generated class for the MysportFriendsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-mysport-friends',
  templateUrl: 'mysport-friends.html',
})
export class MysportFriendsPage {

  @Input("profiles")
  profiles: MySportProfileListItem[];
  @Input("showClose")
  showClose: boolean;
  @Output()
  remove: EventEmitter<number>;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    public translate: TranslateService,
    private userService: UserProvider,
    private loadingCtrl: LoaderProvider,
    public valueService: ValueProvider,
    public sessionService: SessionProvider
  ) {
    this.remove = new EventEmitter<number>();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MysportFriendsPage');
  }

  removeItem(id: number) {
    this.remove.emit(id);
    this.profiles = this.profiles.filter(p => p.id != id);
  }

  emitClick(profile: MySportProfileListItem) {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
  }

}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-friends/mysport-friends.ts